module.exports = __webpack_public_path__ + "img/PRCA2_NK.1abfe5ef.png";